// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__NyvEa","head":"layout_head__zNHaJ","content":"layout_content__3nvs3"};